import { useGetContext } from "@onefront/forrestjs-react-root";

export const useGates = (key) => {
  const gates = useGetContext(`one.gates`);
  if (!gates[key]) {
    console.error(`@oneFront/useGates: gate "${key}" not found or malformed`);
    return [];
  }

  gates[key].flatMap(($) => $.hook).forEach(($) => $());
};
